import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import split from 'ramda/src/split';
import Icon from '@components/@core/Icon';

const useRoutes = () => {
  const loggedIn = useSelector(state => state.app.token)
  return [
    //{ name: 'hcm', icon: 'fa-tasks', path: loggedIn ? '/hcm/dashboard' : '/hcm' },
    //{ name: 'library', icon: 'fa-landmark', path: loggedIn ? '/library/training' : '/library' },
    //{ name: 'analytics', icon: 'fa-chart-bar', path: '/analytics' },
    //{ name: 'community', icon: 'fa-users', path: loggedIn ? '/community/home' : '/community' },
    //{
    //  name: 'vendor-ratings',
    //  icon: 'fa-star',
    //  path: loggedIn ? '/vendor-ratings/home' : '/vendor-ratings',
    //},
    //{ name: 'events', icon: 'fa-calendar-check', path: '/events' },
  ]
}

const Footer = () => {
    const location = useLocation();
    const routes = useRoutes();
    return (
        <div id="ds-footer" className="footer">
            <div className="footer-content">
                <div className="footer-left">
                    {routes.map((nav, idx) => (
                        <NavLink to={nav.path} key={idx}>
                            <Icon name={`fas ${nav.icon} menu-icon ${split('/', location.pathname)[1] === nav.name ? 'active' : ''}`} size={14} color="white" />
                        </NavLink>
                    ))}

                    <div className="divider" />
                    {/*
                    <a href="https://www.facebook.com/DrivingSales/" target="_blank">
                        <Icon name="fab fa-facebook-f ms-3 social-icon" size={14} color="white" />
                    </a>
                    <a href="https://twitter.com/drivingsales" target="_blank">
                        <Icon name="fab fa-twitter social-icon" size={14} color="white" />
                    </a>
                    <a href="https://www.linkedin.com/company/drivingsales-com" target="_blank">
                        <Icon name="fab fa-linkedin-in social-icon" size={14} color="white" />
                    </a>
                    <a href="https://www.youtube.com/user/drivingsales" target="_blank">
                        <Icon name="fab fa-youtube social-icon" size={14} color="white" />
                    </a>
                    */}
                </div>
                <div className="footer-right">
                    <div className="company-info">DrivingSales. All Right Reserved 2019</div>
                </div>
            </div>
        </div>
    );
};

export default Footer;
